import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const CalendarMonth = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 20 20">
    <path d="M15.8333 3.33268H15V1.66602H13.3333V3.33268H6.66667V1.66602H5V3.33268H4.16667C3.24167 3.33268 2.50833 4.08268 2.50833 4.99935L2.5 16.666C2.5 17.5827 3.24167 18.3327 4.16667 18.3327H15.8333C16.75 18.3327 17.5 17.5827 17.5 16.666V4.99935C17.5 4.08268 16.75 3.33268 15.8333 3.33268ZM15.8333 16.666H4.16667V8.33268H15.8333V16.666ZM7.5 11.666H5.83333V9.99935H7.5V11.666ZM10.8333 11.666H9.16667V9.99935H10.8333V11.666ZM14.1667 11.666H12.5V9.99935H14.1667V11.666ZM7.5 14.9993H5.83333V13.3327H7.5V14.9993ZM10.8333 14.9993H9.16667V13.3327H10.8333V14.9993ZM14.1667 14.9993H12.5V13.3327H14.1667V14.9993Z" />
  </SvgIcon>
));

CalendarMonth.displayName = 'CalendarMonth';

export default CalendarMonth;
